
import { filter } from 'rxjs/operators';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  AfterViewInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AHOROS_ACCOUNTING_ENTRY_CATEGORY,
  HOGAR_ACCOUNTING_ENTRIE_CATEGORIE_ID,
  PERSONAL_ACCOUNTING_ENTRY_CATEGORY,
} from 'src/app/utils/consts';
import { lastValueFrom, Subscription } from 'rxjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetOverviewComponent } from '../../widgets/bottom-sheet-overview/bottom-sheet-overview.component';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { getDashboardData } from 'src/app/utils/states-management/actions/dashboard.action';
import { orderAlphabaticallyByAttribute } from 'src/app/utils/array-filtrer';
import { ConnectionService } from 'src/app/services/connection.service';
import { ConnectionState } from 'src/app/utils/states-management/reducers/offline.reducer';
@Component({
  selector: 'app-section-cashflow',
  templateUrl: './section-cashflow.component.html',
  styleUrls: ['./section-cashflow.component.scss'],
})
export class SectionCashflowComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() accountingCategories;
  @Output() dateChange: EventEmitter<any> = new EventEmitter();
  @Input() isDataLoading: boolean;
  global_farm = 0;
  global_family = 0;
  isFarmListOpen = false;
  isFamilyListOpen = false;
  constructor(
    private routerOutlet: IonRouterOutlet,
    private modalController: ModalController,
    private translateService: TranslateService,
    private store: Store<{ connection: ConnectionState }>,
    private connectionService: ConnectionService
  ) {}
  farmCategories = [];
  FamilyCategories = [];
  selectedDate = new Date().toISOString();
  @Input() currency;
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  is_current_month;
  date = new Date().toISOString();
  isOnline = false;
  connectionSubscription: Subscription;
  filterMode: 'year' | 'month' | 'day' = 'year';
  selectedDayDate = new Date().toISOString();
  selectedYearDate = new Date().toISOString();
  ngOnChanges(changes: SimpleChanges): void {
    this.farmCategories = this.accountingCategories.filter(
      (val) => val.is_farm_expenses
    );
    this.farmCategories = orderAlphabaticallyByAttribute(
      this.farmCategories,
      'title',
      this.translateService.currentLang
    );
    this.global_farm = this.farmCategories.reduce((a, b) => a + b.net, 0);

    this.FamilyCategories = this.accountingCategories.filter(
      (val) =>
        !val.is_farm_expenses && val.id != AHOROS_ACCOUNTING_ENTRY_CATEGORY
    );

    this.global_family = this.FamilyCategories.reduce((a, b) => a + b.net, 0);
  }

  async ngOnInit() {
   
    this.store.select('connection').subscribe(async (connection) => {
      this.isOnline = connection.isOnline;
    });
    this.translateService.onLangChange.subscribe(() => {
      this.setTitle();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setTitle();
    }, 0);
  }

  emitPreviousClick() {}

  emitNextClick() {}

  showCalendar(value) {
    this.selectedDate = value;
    setTimeout(() => {
      this.setTitle();
      // this.filterMode = value;
    }, 100);
    this.dateChange.emit(this.getSelectedDateWithMode());
  }

  async setTitle() {

    if (this.filterMode === 'year') {
      const year = new Date(this.selectedYearDate).getFullYear();
      this.date = year.toString();
    } else if (this.filterMode === 'month') {
      const currentMonth = new Date(this.selectedDate).getMonth() + 1;
      const currentYear = new Date(this.selectedDate).getFullYear();

      this.month === currentMonth && this.year === currentYear
        ? (this.is_current_month = true)
        : (this.is_current_month = false);

      const monthNames = await this.translateService.instant('monthNames');

      if (monthNames && monthNames[currentMonth - 1]) {
        this.date = monthNames[currentMonth - 1] + ' ' + currentYear;
      } else {
        this.date = new Date(this.selectedDate).toLocaleDateString();
      }
    } else {
      const selectedDate = new Date(this.selectedDayDate);
      const today = new Date();

      this.is_current_month =
        selectedDate.toDateString() === today.toDateString();

      const monthNames = await this.translateService.instant('monthNames');

      if (monthNames && monthNames[selectedDate.getMonth()]) {
        const day = selectedDate.getDate().toString().padStart(2, '0');
        const month = monthNames[selectedDate.getMonth()].substring(0, 3);
        const year = selectedDate.getFullYear();

        this.date = `${day}-${month}-${year}`;
      } else {
        this.date = selectedDate.toLocaleDateString();
      }
    }

  }

  previousMonth() {
    if (this.filterMode === 'year') {
      const date = new Date(this.selectedYearDate);
      date.setFullYear(date.getFullYear() - 1);
      this.selectedYearDate = date.toISOString();
    } else if (this.filterMode === 'month') {
      const date = new Date(this.selectedDate);
      date.setMonth(date.getMonth() - 1);
      this.selectedDate = date.toISOString();
    } else {
      const date = new Date(this.selectedDayDate);
      date.setDate(date.getDate() - 1);
      this.selectedDayDate = date.toISOString();
    }
    this.setTitle();
    this.dateChange.emit(this.getSelectedDateWithMode());
  }

  nextMonth() {
    if (this.filterMode === 'year') {
      const date = new Date(this.selectedYearDate);
      date.setFullYear(date.getFullYear() + 1);
      this.selectedYearDate = date.toISOString();
    } else if (this.filterMode === 'month') {
      const date = new Date(this.selectedDate);
      date.setMonth(date.getMonth() + 1);
      this.selectedDate = date.toISOString();
    } else {
      const date = new Date(this.selectedDayDate);
      date.setDate(date.getDate() + 1);
      this.selectedDayDate = date.toISOString();
    }
    this.setTitle();
    this.dateChange.emit(this.getSelectedDateWithMode());
  }

  async openBottomSheet(item): Promise<void> {
    let componentProps = {
      item: item,
      modalController: this.modalController,
      date: this.date,
      filterMode: this.filterMode,
      selectedDate: this.getSelectedDate(),
    };
    const modal = await this.modalController.create({
      component: BottomSheetOverviewComponent,
      componentProps,
      cssClass: ['custom-modal-sheet', 'height-45', 'modal-wrapper'],
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl,
      animated: true,
      mode: 'ios',
      showBackdrop: false,
    });
    return await modal.present();
  }

  handelListClicked(variable) {
    this[variable] = !this[variable];
  }

  getSelectedDate(): any {
    return this.filterMode === 'year'
      ? this.selectedYearDate
      : this.filterMode === 'month'
      ? this.selectedDate
      : this.selectedDayDate;
  }

  getSelectedDateWithMode(): {
    date: any;
    filterMode: 'year' | 'month' | 'day';
  } {
    return {
      date:
        this.filterMode === 'year'
          ? this.selectedYearDate
          : this.filterMode === 'month'
          ? this.selectedDate
          : this.selectedDayDate,
      filterMode: this.filterMode,
    };
  }

  get currentDate(): string {
    if (this.filterMode === 'year') return this.selectedYearDate;
    if (this.filterMode === 'month') return this.selectedDate;
    return this.selectedDayDate;
  }

  set currentDate(value: string) {
    if (this.filterMode === 'year') {
      this.selectedYearDate = value;
    } else if (this.filterMode === 'month') {
      this.selectedDate = value;
    } else {
      this.selectedDayDate = value;
    }
  }

  changeFilterMode(mode: 'year' | 'month' | 'day',  newYear?: string) {
    this.filterMode = mode;
    

    if (mode === 'day') {
      const monthDate = new Date(this.selectedDate);
      this.selectedDayDate = new Date(
        monthDate.getFullYear(),
        monthDate.getMonth(),
        1
      ).toISOString();
    } else if (mode === 'month') {
      const dayDate = new Date(this.selectedDayDate);
      this.selectedDate = new Date(
        dayDate.getFullYear(),
        dayDate.getMonth(),
        1
      ).toISOString();
    } else { 
      let yearToUse: number;
      if (newYear) {
        const dateFromNewYear = new Date(newYear);
        if (!isNaN(dateFromNewYear.getTime())) { 
          yearToUse = dateFromNewYear.getFullYear();
        } else {
          yearToUse = new Date().getFullYear(); 
        }
      } else {
        yearToUse = new Date().getFullYear(); 
      }
      this.selectedYearDate = new Date(yearToUse, 0, 1).toISOString();
    }

    this.setTitle();
    this.dateChange.emit(this.getSelectedDateWithMode());
  }
}
